import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { seoData } from '../../global/seoData';
import { globalVal } from '../../global/globalvalues';
import SimpleHeader from '../../components/Header/simpleHeader';
import Footer from '../../components/Footer/Footer';
import image from '../../Assets/images/PreLogin/PRELOGINBANNER.png';
import image1 from '../../Assets/images/PreLogin/PRELOGINBANNERIPAD.png';
import image2 from '../../Assets/images/PreLogin/PRELOGINBANNERMWEB.png';
import './PreLogin.scss';
import signalIcon from '../../Assets/images/PreLogin/signalIcon.svg';
import monitorIcon from '../../Assets/images/PreLogin/monitorIcon.svg';
import Button from '../../components/Button/Button';
import { CircularProgress } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

type initialProps = {
    history: any;
};
interface ReadOnlyURLSearchParams extends URLSearchParams {
    append: never;
    set: never;
    delete: never;
    sort: never;
}

const AstoundPreLogin = (props: initialProps) => {
    const [loader, setLoader] = useState<boolean>(true);

    const { search } = useLocation();

    const searchParams = useMemo(() => new URLSearchParams(search) as ReadOnlyURLSearchParams, [search]);

    useEffect(() => {
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        if (customerDetail) {
            if (customerDetail.status === 0) {
                props.history.push({ pathname: '/home', state: customerDetail });
            } else if (
                customerDetail.status == 1 ||
                customerDetail.status == 2 ||
                customerDetail.status == 3 ||
                customerDetail.status == 4 ||
                customerDetail.status == 5 ||
                customerDetail.status == 8 ||
                customerDetail.status == 9 ||
                customerDetail.status == 10 ||
                customerDetail.status == 11
            ) {
                props.history.push('/post-activation-home');
            } else {
                setLoader(false);
            }
        } else {
            setLoader(false);
        }
        window.scroll(0, 0);
        if (searchParams.get('redirect_url')) {
            let redirect_url = searchParams.get('redirect_url');
            window.location.href = `${redirect_url}`;
            console.log(redirect_url);
        }
    }, []);

    const loginHandler = () => {
        window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_PRE_LOGIN_URL}`;
    };

    return (
        <>
            {' '}
            {loader ? (
                <div className="loader">
                    <CircularProgress />
                </div>
            ) : (
                <div className="PreLoginMain">
                    <Helmet>
                        <title>{seoData.preLogin.title}</title>
                        <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                        <meta property="og:title" name="title" content={seoData.preLogin.title} />
                        <meta property="og:description" name="description" content={seoData.preLogin.description} />
                        <meta name="keywords" content={seoData.preLogin.keywords} />
                        <meta
                            property="twitter:site_name"
                            name="site_name"
                            content={globalVal && globalVal.long_name}
                        />
                        <meta name="twitter:title" content={seoData.preLogin.title} />
                        <meta name="twitter:description" content={seoData.preLogin.description} />
                        <link rel="canonical" href={seoData.preLogin.canonicalUrl} />
                        <meta
                            key="robots"
                            name="robots"
                            content={
                                process.env.REACT_APP_SERVER_NAME == 'astound-prod'
                                    ? 'index follow'
                                    : 'noindex nofollow'
                            }
                        />
                        <link rel="canonical" href={seoData.home.canonicalUrl} />
                    </Helmet>
                    <SimpleHeader history={props.history} />
                    <div className="OverlayPostPreLogin">
                        <div className="carouseImage">
                            <img className="web" src={image} width="100%" alt="Astound banner image" />
                            <img className="iPadPro" src={image1} width="100%" alt="Astound banner image" />
                            <img className="iPad" src={image1} width="100%" alt="Astound banner image" />
                            <img className="mobile" src={image2} width="100%" alt="Astound banner image" />
                            <div className="contentCarousel">
                                <h1 style={{ display: 'none' }}>Astound Mobile</h1>
                                <div className="Goodbye-mobile-store">Welcome to Astound Mobile</div>
                                <div className="subtitle">
                                    Activate your phone in three easy steps:
                                    <br />
                                    Login, activate & enjoy!
                                </div>
                                <div className="loginBtn">
                                    <Button primary={true} onClick={loginHandler}>
                                        Login
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="preLoginContent">
                            <div className="content">
                                <div className="leftCont">
                                    <div className="image">
                                        <img src={signalIcon} alt="Signal icon" />
                                    </div>
                                    <div className="text">Get Astound Mobile</div>
                                    <div className="desc">Reliable service at affordable prices.</div>
                                    <div className="button">
                                        <Button
                                            primary={true}
                                            onClick={() =>
                                                (window.location.href = `${process.env.REACT_APP_LEARN_MORE}`)
                                            }
                                        >
                                            Learn More
                                        </Button>
                                    </div>
                                </div>
                                <div className="vLine"></div>
                                <div className="rightCont">
                                    <div className="image">
                                        <img src={monitorIcon} alt="Monitor icon" />
                                    </div>
                                    <div className="text">Manage Your Account</div>
                                    <div className="desc">Manage your Astound services</div>
                                    <div className="button">
                                        <Button primary={true} onClick={loginHandler}>
                                            Login
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )}
        </>
    );
};

export default AstoundPreLogin;
